import { createContext } from "react";
import {
  FormattedOwnerData,
  OwnerData,
} from "../../models/ownerData/ownerData.model";
import { UserData } from "../../models/login/login.model";
import { SnackbarData } from "../../models/snackbar/snackbar.model";
import { CifCupsState } from "../../models/cupsCifSelector/cupsCifSelector.model";
import { ManagementsDetailHeader } from "../../models/managements/managements.model";

export interface TotalEnergiesCreateContext {
  ownerData: FormattedOwnerData | null;
  storageOwnerData: (ownerData: OwnerData) => void;
  userData: UserData | null;
  setUserData: React.Dispatch<React.SetStateAction<UserData | null>>;
  storageUserData: (userData: UserData) => void;
  snackbarData: SnackbarData;
  setSnackbarData: React.Dispatch<React.SetStateAction<SnackbarData>>;
  cifCupsState: CifCupsState;
  storageCifCupsState: (cifCupsState: CifCupsState) => void;
  managementsDetailHeader: ManagementsDetailHeader;
  setManagementsDetailHeader: React.Dispatch<
    React.SetStateAction<ManagementsDetailHeader>
  >;
  isAgent: boolean | null;
  setIsAgent: React.Dispatch<React.SetStateAction<boolean | null>>;
  isEntitySelected: boolean;
  setIsEntitySelected: React.Dispatch<React.SetStateAction<boolean>>;
  selectedEntityList: string[];
  setSelectedEntityList: React.Dispatch<React.SetStateAction<string[]>>;
}

const TotalEnergiesContext = createContext<TotalEnergiesCreateContext>(
  {} as TotalEnergiesCreateContext
);

TotalEnergiesContext.displayName = "Total Energies Context";

export default TotalEnergiesContext;
